import { Button } from '@storeblocks/button';
import { type FC } from 'react';
import styled from 'styled-components';

import { appConfig } from '@/constants/config';
import { useTexts } from '@/hooks/useTexts';

export const FooterBanner: FC = () => {
  const texts = useTexts();
  return (
    <Banner>
      <Center>
        <Button
          variant="tertiary"
          iconRight="arrow_up"
          onClick={() => window.scrollTo(0, 0)}
        >
          {texts.footer.scrollToTop}
        </Button>
      </Center>
    </Banner>
  );
};

const Banner = styled.div`
  padding: 4px 0;
`;

const Center = styled.div`
  max-width: ${appConfig.maxPageWidth};
  margin: 0 auto;
`;
